import React from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import { resolveMediaUrl } from "../../utils/seo";

const DoctorImage = ({
  width = "100%",
  height = "100%",
  scr,
  alt = "تصویر پزشک",
}) => (
  <img
    src={resolveMediaUrl(scr)}
    alt={alt}
    className="img-fluid rounded-circle"
    width={width}
    height={height}
    loading="eager"
    fetchPriority="high"
  />
);

export default DoctorImage;
